import ArrowThickRightIcon from './arrow-thick-right.svg';

const ArrowThickRight = (props) => <ArrowThickRightIcon {...props} focusable="false" />;

export default ArrowThickRight;
